import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function CircularLoader() {
  return (
    <Box sx={{ display: 'flex' }}>
      <div class="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin pointer-events-auto cursor-wait"></div>
    </Box>
  );
}